import * as ReselectModule from "reselect";
import { IAssistanceDocumentListState } from ".";
import { IApplicationState } from "..";

export const selectAssistanceDocumentList: ReselectModule.Selector<
  IApplicationState,
  IAssistanceDocumentListState
> = (state) => state.assistanceDocumentList;
